import { render } from "./set_password.vue?vue&type=template&id=70c5c0be&scoped=true"
import script from "./set_password.vue?vue&type=script&lang=js"
export * from "./set_password.vue?vue&type=script&lang=js"

import "./set_password.vue?vue&type=style&index=0&id=70c5c0be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c5c0be"]])

export default __exports__